/* eslint-disable code-style/folder-structure-consistency */

export const routesUrlsData = {
    admins: {
        create: "/admins/create",
        url: "/admins",
    },
    auth: {
        login: "/auth/login",
        setPassword: "/auth/set-password",
    },
    events: {
        create: "/events/create",
        guests: "/guests",
        photos: "/photos",
        retouchQueue: "/retouch-queue",
        slideshow: "/slideshow",
        templates: {
            create: "/templates/create",
            url: "/templates",
        },
        url: "/events",
    },
    photographers: {
        create: "/photographers/create",
        url: "/photographers",
    },
    routeSegments: {
        admins: "admins",
        auth: "auth",
        create: "create",
        eventGuestPhotos: ":eventId/guests/:guestId/photos",
        events: "events",
        guests: ":id/guests",
        login: "login",
        notFound: "*",
        photographers: "photographers",
        photos: ":id/photos",
        retouchQueue: ":id/retouch-queue",
        root: "/",
        setPassword: "set-password",
        slideshow: ":id/slideshow",
        templatesCreate: "templates/create",
        templatesIndex: "templates",
        templatesUpdate: "templates/:id/update",
        update: ":id/update",
    },
    update: "/update",
};
